export default "__VITE_ASSET__B2dKg0_B__"